import { render, staticRenderFns } from "./StatisticsSalesItems.vue?vue&type=template&id=43a88b3c&scoped=true&"
import script from "./StatisticsSalesItems.vue?vue&type=script&lang=js&"
export * from "./StatisticsSalesItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a88b3c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43a88b3c')) {
      api.createRecord('43a88b3c', component.options)
    } else {
      api.reload('43a88b3c', component.options)
    }
    module.hot.accept("./StatisticsSalesItems.vue?vue&type=template&id=43a88b3c&scoped=true&", function () {
      api.rerender('43a88b3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Admin/Dashboard/StatisticsSalesItems.vue"
export default component.exports